import http from '@/plugins/axios';
export async function getRoomPrinter(retauarant) {
    const response = await http.get('cashier/get-printers?restaurant_id=' + retauarant);
    return response.data.data;
}

export async function updatePrinter(payload) {
    const response = await http.post('cashier/update-printer', payload);
    return response;
}
export async function getPrintDetails(payload) {
    const response = await http.get('cashier/order/' + payload + '/for-print');
    return response.data.data;
}

export async function userSetting(payload) {
    const response = await http.post('user-setting', payload);
    return response.data.data;
}
export async function getUserSetting() {
    const response = await http.get('user-setting/print_service_api');
    return response.data.data;
}

export async function AddQtyPrint(payload) {
    const response = await http.post('cashier/order/add-print-qty', payload);
    return response.data.data;
}




